import { Box, Button, Modal } from "@mui/material";
// import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

function BattleShips() {
    const [ships, setShips] = useState([
        { name: "destroyer", isVisible: true, shipSize: 2 },
        { name: "submarine", isVisible: true, shipSize: 3 },
        { name: "cruiser", isVisible: true, shipSize: 3 },
        { name: "battleship", isVisible: true, shipSize: 4 },
        { name: "carrier", isVisible: true, shipSize: 5 },
        { name: "boat", isVisible: true, shipSize: 1 },
    ]);
    const [pcShipsBlocks, setPcShipsBlocks] = useState([]);
    const [playerShipsBlocks, setPlayerShipsBlocks] = useState([]);
    const [pcAttackedBlocks, setPcAttackedBlocks] = useState(0);
    const [playerAttackedBlocks, setPlayerAttackedBlocks] = useState([]);
    const [gameStarted, setGameStarted] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [horizontal, setHorizontal] = useState(true);
    const [pcTurn, setPcTurn] = useState(false);
    const [pcTryAgain, setPcTryAgain] = useState(0);
    const [currentSuccessAttack, setCurrentSuccessAttack] = useState([]);
    const [firstSuccessAttack, setFirstSuccessAttack] = useState([]);
    const [hittedBlocks, setHittedBlocks] = useState([]);
    const [nextSuccessAttack, setNextSuccessAttack] = useState(null);
    const [tryHorizontalAttack, setTryHorizontalAttack] = useState(true);
    const [decrement, setDecrement] = useState(1);
    const [gameEnd, setGameEnd] = useState(false);
    const [yourScore, setYourScore] = useState(0);
    const [pcScore, setPcScore] = useState(0);
    const [bubbleSpeech, setBubbleSpeech] = useState("");
    const [touchInfo, setTouchInfo] = useState({ touchX: null, touchY: null, shipName: null });
    const [isDragging, setIsDragging] = useState(false);

    const draggedShipRef = useRef(null);
    const droppedShipRef = useRef(false);
    const horizontalRef = useRef(true);
    const shipSizeRef = useRef(0);
    const shipsRef = useRef([]);
    const playerShipsBlocksRef = useRef([]);
    const pcShipsBlocksRef = useRef([]);
    const timeoutIdRef = useRef(null);

    function isMobile() {
        return /iPhone|iPad|iPod|Android|Mobile/i.test(navigator.userAgent);
    }

    useEffect(() => {
        createBoards();
        setPcShips();
    }, []);

    useEffect(() => {
        function handleTouchMove(e) {
            if (isDragging && e.cancelable) {
                e.preventDefault();
            }
        }

        if (isDragging) {
            window.addEventListener("touchmove", handleTouchMove, { passive: false });
        } else {
            window.removeEventListener("touchmove", handleTouchMove);
        }

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener("touchmove", handleTouchMove);
        };
    }, [isDragging]);

    useEffect(() => {
        // Function to update the bubble speech text
        function updateBubbleSpeech() {
            let text = "";

            if (gameStarted && hittedBlocks.length === 0) {
                text = "Good Luck!";
            }

            if (pcAttackedBlocks === 1) {
                text = "Ooh!";
            }

            if (pcAttackedBlocks === 10) {
                text = "Pfff";
            }

            if (pcAttackedBlocks === 15) {
                text = "Agrrr";
            }

            if (pcAttackedBlocks === 18) {
                text = "Lucky!";
            }

            if (playerAttackedBlocks.length === 1 || playerAttackedBlocks.length === 8 || playerAttackedBlocks.length === 16) {
                text = "Woopsy!";
            }

            if (playerAttackedBlocks.length === 15) {
                text = "I'm close to winning!";
            }

            if (playerAttackedBlocks.length === 18) {
                text = "Easy!";
            }

            if (gameStarted && text === "") {
                timeoutIdRef.current = setTimeout(() => {
                    text = "Zzzz";
                    setBubbleSpeech(text);
                }, 8000);
            } else {
                // Clear the timeout when conditions don't match
                clearTimeout(timeoutIdRef.current);
            }

            setBubbleSpeech(text);
        }

        // Call the function initially and whenever dependencies change
        updateBubbleSpeech();

        // Clean up any existing timeout when the component unmounts or when the message changes to "Zzzz"
        return () => clearTimeout(timeoutIdRef.current);
    }, [gameStarted, hittedBlocks.length, pcAttackedBlocks, playerAttackedBlocks.length]);

    useEffect(() => {
        if (pcAttackedBlocks === 18) {
            setGameEnd(true);
            setYourScore((prevValue) => prevValue + 1);
        }

        if (playerAttackedBlocks.length === 18) {
            setGameEnd(true);
            setPcScore((prevValue) => prevValue + 1);
        }
    }, [playerAttackedBlocks.length, pcAttackedBlocks]);

    useEffect(() => {
        pcAttack();
    }, [pcTurn, pcTryAgain]);

    useEffect(() => {
        horizontalRef.current = horizontal;
    }, [horizontal]);

    // Update the ref whenever pcShipsBlocks changes
    useEffect(() => {
        pcShipsBlocksRef.current = pcShipsBlocks;
    }, [pcShipsBlocks]);

    useEffect(() => {
        if (playerShipsBlocks.length === 18) {
            setGameStarted(true);
        }
        playerShipsBlocksRef.current = playerShipsBlocks;
    }, [playerShipsBlocks]);

    function createBoards() {
        const playersBoard = document.querySelector("#playerBoard");
        const pcsBoard = document.querySelector("#pcBoard");

        // Remove all child elements from the playersBoard and pcsBoard containers
        playersBoard.innerHTML = "";
        pcsBoard.innerHTML = "";

        for (let i = 0; i < 100; i++) {
            const playerBlocks = document.createElement("div");
            const pcBlocks = document.createElement("div");
            pcBlocks.key = i;
            pcBlocks.id = i;
            pcBlocks.addEventListener("click", () => playerAttack(i));
            pcsBoard.append(pcBlocks);
            playerBlocks.id = i + 100;
            playerBlocks.addEventListener("dragover", dragOver);
            playerBlocks.addEventListener("drop", dropShip);
            playersBoard.append(playerBlocks);
        }
    }

    function createArrayForEachRow() {
        const rows = [];
        for (let i = 0; i < 10; i++) {
            const row = [];
            for (let j = 0; j < 10; j++) {
                row.push(100 + i * 10 + j);
            }
            rows.push(row);
        }
        return rows;
    }

    function createArrayForEachColumn() {
        const columns = [];
        for (let i = 0; i < 10; i++) {
            const column = [];
            for (let j = 0; j < 10; j++) {
                column.push(100 + j * 10 + i);
            }
            columns.push(column);
        }
        return columns;
    }

    function splitConsecutiveNumbers(arr, hittedBlocks, isColumn) {
        const splitArray = [];
        let temp = [];

        for (let i = 0; i < arr.length; i++) {
            if (hittedBlocks.includes(arr[i])) {
                if (temp.length > 0) {
                    splitArray.push(temp);
                    temp = [];
                }
            } else {
                if (temp.length === 0 || arr[i] === (isColumn ? arr[i - 1] + 10 : arr[i - 1] + 1)) {
                    temp.push(arr[i]);
                } else {
                    splitArray.push(temp);
                    temp = [arr[i]];
                }
            }
        }

        if (temp.length > 0) {
            splitArray.push(temp);
        }

        return splitArray;
    }

    function findRowsAndColumnsWithHits(hittedBlocks) {
        const rowsWithHits = new Set();
        const columnsWithHits = new Set();

        for (const block of hittedBlocks) {
            const row = Math.floor(block / 10) * 10;
            const column = block % 10;

            rowsWithHits.add(row);
            columnsWithHits.add(column);
        }

        return { rows: Array.from(rowsWithHits), columns: Array.from(columnsWithHits) };
    }

    function combineArrays(hittedBlocks) {
        const rows = createArrayForEachRow();
        const columns = createArrayForEachColumn();
        const { rows: rowsWithHits, columns: columnsWithHits } = findRowsAndColumnsWithHits(hittedBlocks);
        const combinedArrays = [];

        for (const row of rows) {
            if (rowsWithHits.includes(row[0])) {
                const splitRow = splitConsecutiveNumbers(row, hittedBlocks, false);
                combinedArrays.push(...splitRow);
            } else {
                combinedArrays.push(row);
            }
        }

        for (const column of columns) {
            const columnNumber = column[0] % 10; // Extract the column number from the first block in the column
            let columnIsHit = columnsWithHits.includes(columnNumber);

            if (columnIsHit) {
                // If any block in the column is hit, split the column
                const splitColumn = splitConsecutiveNumbers(column, hittedBlocks, true);
                combinedArrays.push(...splitColumn);
            } else {
                // If no block in the column is hit, keep the column as it is
                combinedArrays.push(column);
            }
        }

        return combinedArrays;
    }

    function getRandomNumberFromBiggestSet(hittedBlocks) {
        const combinedArrays = combineArrays(hittedBlocks);

        // Find the biggest set of numbers
        let biggestSet = [];
        for (const set of combinedArrays) {
            if (set.length > biggestSet.length) {
                biggestSet = set;
            }
        }

        // If there are multiple sets with the same size, randomly choose one
        const biggestSets = combinedArrays.filter((set) => set.length === biggestSet.length);
        const randomSet = biggestSets[Math.floor(Math.random() * biggestSets.length)];

        // Randomly choose a number from the biggest set
        const randomNumber = randomSet[Math.floor(Math.random() * randomSet.length)];

        return randomNumber;
    }

    // Returns a random number that is not present in the excludedNumbers array.
    // The function uses a do-while loop to repeatedly generate a random number
    // until a unique number is found.
    function getRandomStartNumber(min, max, excluded) {
        let randomNumber;
        do {
            randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        } while (excluded.includes(randomNumber));
        return randomNumber;
    }

    // Sets the positions of computer ships on the board.
    // The function iterates through the ships array and assigns random positions to each ship.
    // It ensures that the ships don't overlap and that they fit within the board's boundaries.
    function setPcShips() {
        const allBoardBlocks = document.querySelectorAll("#pcBoard div");
        let newPcShipsBlocks = [];
        let excludedNumbers = [];

        for (let i = 0; i < ships.length; i++) {
            let randomBoolean = Math.random() < 0.5;
            let isHorizontal = randomBoolean;
            let randomStartNumber = getRandomStartNumber(0, 99, excludedNumbers);
            let shipBlocks = [];
            let validStartNumber;

            if (isHorizontal) {
                if (randomStartNumber <= 100 - ships[i].shipSize) {
                    validStartNumber = randomStartNumber;
                } else {
                    validStartNumber = 100 - ships[i].shipSize;
                }
            } else {
                if (randomStartNumber <= 100 - 10 * ships[i].shipSize) {
                    validStartNumber = randomStartNumber;
                } else {
                    validStartNumber = randomStartNumber - ships[i].shipSize * 20;
                }
            }

            for (let y = 0; y < ships[i].shipSize; y++) {
                if (isHorizontal) {
                    const index = Number(validStartNumber) + y;
                    if (index >= 0 && index <= allBoardBlocks.length) {
                        excludedNumbers.push(validStartNumber + y);
                        shipBlocks.push(Number(allBoardBlocks[index].id));
                    } else {
                        // If the ship doesn't fit within the board, restart the ship placement process
                        setPcShips();
                        return;
                    }
                } else {
                    const index = Number(validStartNumber) + y * 10;
                    if (index >= 0 && index < allBoardBlocks.length) {
                        excludedNumbers.push(validStartNumber + y * 10);
                        shipBlocks.push(Number(allBoardBlocks[index].id));
                    } else {
                        // If the ship doesn't fit within the board, restart the ship placement process
                        setPcShips();
                        return;
                    }
                }
            }

            let valid;

            // Check if the ship's position is valid and not overlapping with other ships.
            if (isHorizontal) {
                valid = shipBlocks.every((_shipBlock, index) => shipBlocks[0] % 10 !== 10 - (shipBlocks.length - (index + 1)));
            } else {
                valid = shipBlocks.every((_shipBlock, index) => shipBlocks[0] < 90 + (10 * index + 1));
            }

            // Check if any of the shipBlocks are already taken by other ships.
            const takenBlocks = newPcShipsBlocks.reduce((acc, val) => acc.concat(val), []);
            const notTaken = shipBlocks.every((pcBlock) => !takenBlocks.includes(pcBlock));

            // If the ship's position is valid and not taken, add it to the newPcShipsBlocks array.
            if (valid && notTaken) {
                newPcShipsBlocks = [...newPcShipsBlocks, ...shipBlocks];
            } else {
                // If the ship's position is not valid or taken, restart the ship placement process.
                setPcShips();
                return;
            }
        }
        // Set the final positions of the computer ships on the board.
        setPcShipsBlocks(newPcShipsBlocks);
    }

    // Set Player's Ships
    function setUserShips(startId, shipId) {
        const allBoardBlocks = document.querySelectorAll("#playerBoard div");
        const draggedShip = document.getElementsByClassName(touchInfo.shipName);
        const ship = ships[shipId];

        let isHorizontal = horizontalRef.current;
        let shipBlocks = [];
        let validStartNumber;
        let validStartId;
        let valid;

        if (isHorizontal) {
            validStartId = startId - shipSizeRef.current;
            if (validStartId <= 200 - ship.shipSize) {
                validStartNumber = validStartId;
            } else {
                validStartNumber = 200 - ship.shipSize;
            }
        } else {
            validStartId = startId - shipSizeRef.current * 10;
            if (validStartId <= 200 - 10 || ship.shipSize === 1) {
                validStartNumber = validStartId;
            } else {
                validStartNumber = validStartId - ship.shipSize * 20 + 100;
            }
        }

        for (let y = 0; y < ship.shipSize; y++) {
            if (isHorizontal) {
                const index = Number(validStartNumber) + y - 100;
                if (index >= 0 && index <= allBoardBlocks.length) {
                    shipBlocks.push(Number(allBoardBlocks[index].id));
                } else {
                    // If the ship doesn't fit within the board, restart the ship placement process
                    if (isMobile()) {
                        draggedShip[0].style.transform = "translate(0, 0)";
                    }
                    droppedShipRef.current = false;
                    return;
                }
            } else {
                const index = Number(validStartNumber) + y * 10 - 100;
                if ((index >= 0 && index < allBoardBlocks.length) || ship.shipSize === 1) {
                    if (ship.shipSize === 1) {
                        shipBlocks.push(Number(allBoardBlocks[index].id));
                    } else {
                        shipBlocks.push(Number(allBoardBlocks[index].id));
                    }
                } else {
                    // If the ship doesn't fit within the board, restart the ship placement process
                    if (isMobile()) {
                        draggedShip[0].style.transform = "translate(0, 0)";
                    }
                    droppedShipRef.current = false;
                    return;
                }
            }
        }

        // Check if the ship's position is valid and not overlapping with other ships.
        if (isHorizontal) {
            valid = shipBlocks.every((_shipBlock, index) => shipBlocks[0] % 10 !== 10 - (shipBlocks.length - (index + 1)));
        } else if (ship.shipSize === 1) {
            valid = true;
        } else {
            valid = shipBlocks.every((_shipBlock, index) => shipBlocks[0] < 190 + (10 * index + 1));
        }

        // Check if any of the shipBlocks are already taken by other ships.
        const takenBlocks = playerShipsBlocksRef.current.reduce((acc, val) => acc.concat(val), []);

        // If the ship's position is valid and not taken, add it to the newPlayerShipsBlocks array.
        if (valid && shipBlocks.every((pcBlock) => !takenBlocks.includes(pcBlock))) {
            shipBlocks.forEach((blockId) => {
                const shipDiv = document.createElement("span");
                shipDiv.classList.add(ship.name, "placedShip");
                allBoardBlocks[blockId - 100].appendChild(shipDiv);
            });

            // Set the ship's visibility to false after it's placed on the board
            const updatedShips = shipsRef.current.map((ship, index) => (index === parseInt(shipId) ? { ...ship, isVisible: false } : ship));
            setShips(updatedShips);

            setPlayerShipsBlocks((prevPlayerShipsBlocks) => [...prevPlayerShipsBlocks, ...shipBlocks]);

            droppedShipRef.current = true;
        } else {
            // If the ship's position is not valid or taken, restart the ship placement process.
            if (isMobile()) {
                draggedShip[0].style.transform = "translate(0, 0)";
            }
            droppedShipRef.current = false;
            return;
        }
    }

    function touchStart(e) {
        shipsRef.current = [...ships];
        droppedShipRef.current = false;

        if (isMobile()) {
            shipSizeRef.current = parseInt(e.target.id);
            draggedShipRef.current = e.target.parentNode.id;
            const touch = e.touches[0];
            const offsetX = touch.clientX;
            const offsetY = touch.clientY;
            setTouchInfo({ touchX: offsetX, touchY: offsetY, shipName: e.target.parentNode.classList[1] });
            setIsDragging(true);
        } else {
            draggedShipRef.current = e.target.id;
            e.dataTransfer.effectAllowed = "move";
        }
    }

    function touchMove(e) {
        if (isMobile()) {
            const touch = e.targetTouches[0];
            const shipX = touch.clientX - touchInfo.touchX;
            const shipY = touch.clientY - touchInfo.touchY;
            const shipElement = document.getElementsByClassName(touchInfo.shipName);
            shipElement[0].style.transform = `translate(${shipX}px, ${shipY}px)`;
        } else {
            e.preventDefault();
        }
    }

    function touchEnd(e) {
        if (isMobile()) {
            const ship = document.getElementsByClassName(touchInfo.shipName);
            const boardContainer = document.getElementById("playerBoard");

            // Check if the ship is dropped within the board container
            const rect = boardContainer.getBoundingClientRect();
            const boardX = rect.left;
            const boardY = rect.top;
            const dropX = e.changedTouches[0].clientX - boardX;
            const dropY = e.changedTouches[0].clientY - boardY;
            const shipWidth = ship[0].offsetWidth;
            const shipHeight = ship[0].offsetHeight;

            if (
                dropX >= -shipWidth * 0.9 && // At least 90% of the ship's width to the left of the board
                dropX < boardContainer.offsetWidth + shipWidth * 0.9 && // At least 90% of the ship's width to the right of the board
                dropY >= -shipHeight * 0.9 && // At least 90% of the ship's height above the board
                dropY < boardContainer.offsetHeight + shipHeight * 0.9 // At least 90% of the ship's height below the board
            ) {
                // The ship is dropped within the board container, handle the drop logic here
                const blockSize = boardContainer.offsetWidth / 10; // Assuming the board is a 10x10 grid
                const row = Math.floor(dropY / blockSize);
                const col = Math.floor(dropX / blockSize);
                const blockId = row * 10 + col + 100; // Calculate the ID of the block based on row and column indices

                // Now you have the row and column indices and the block ID where the ship is dropped
                dropShip(e, blockId);

                // You can also call the setUserShips function here passing the shipId and blockId as arguments
                // setUserShips(shipId, blockId);
            } else {
                // Reset the ship's position to its original location
                ship[0].style.transform = "translate(0, 0)";
            }
            setIsDragging(false);
        }
    }

    function dragOver(e) {
        e.preventDefault();
    }

    function dropShip(e, blockId) {
        let startId;

        if (isMobile()) {
            startId = parseInt(blockId);
        } else {
            startId = parseInt(e.target.id);
        }
        const shipId = draggedShipRef.current;

        setUserShips(startId, shipId);

        if (!droppedShipRef.current) {
            draggedShipRef.current = null;
        }
    }

    function playerAttack(id) {
        const clickedBlock = document.querySelector(`#pcBoard div[id="${id}"]`);
        const parsedId = parseInt(id);

        // Check if the clicked id exists in the pcShipsBlocks array
        if (pcShipsBlocksRef.current.includes(parsedId)) {
            // The id exists in the pcShipsBlocks array
            clickedBlock.classList.add("success-att");
            setPcAttackedBlocks((prevValue) => prevValue + 1);
        } else {
            // The id does not exist in the pcShipsBlocks array
            clickedBlock.classList.add("missed-att");
        }

        setPcTurn(true);
    }

    async function pcAttack() {
        if (pcTurn === false || gameEnd === true) {
            return;
        }

        const leftWallBlocks = [109, 119, 129, 139, 149, 159, 169, 179, 189, 199];
        const rightWallBlocks = [100, 110, 120, 130, 140, 150, 160, 170, 180, 190];

        let hitId;

        if (currentSuccessAttack.length >= 1) {
            if (tryHorizontalAttack) {
                if (nextSuccessAttack === true) {
                    hitId = currentSuccessAttack[currentSuccessAttack.length - 1] + 1;
                    if (playerAttackedBlocks.includes(hitId) && !leftWallBlocks.includes(hitId - 1)) {
                        hitId += 1;
                    }
                    if (leftWallBlocks.includes(hitId - 1)) {
                        hitId = 0;
                    }
                } else if (nextSuccessAttack === false) {
                    if (currentSuccessAttack.length > 1) {
                        hitId = firstSuccessAttack[0] - decrement;
                        setDecrement((prevDecrement) => prevDecrement + 1);
                    } else {
                        hitId = firstSuccessAttack[0] - 1;
                    }
                    if (playerAttackedBlocks.includes(hitId) && !rightWallBlocks.includes(hitId + 1)) {
                        hitId -= 1;
                    }
                    if (rightWallBlocks.includes(hitId + 1)) {
                        hitId = 0;
                    }
                }
            } else {
                if (nextSuccessAttack === true) {
                    hitId = currentSuccessAttack[currentSuccessAttack.length - 1] + 10;
                    if (playerAttackedBlocks.includes(hitId)) {
                        hitId += 10;
                    }
                } else if (nextSuccessAttack === false) {
                    hitId = firstSuccessAttack[0] - decrement * 10;
                    setDecrement((prevDecrement) => prevDecrement + 1);
                    if (playerAttackedBlocks.includes(hitId)) {
                        hitId -= 10;
                    }
                }
            }
        } else {
            hitId = getRandomNumberFromBiggestSet(hittedBlocks);
        }

        let notValidHitId;

        if (!hittedBlocks.includes(hitId) && hitId < 200 && hitId >= 100) {
            notValidHitId = false;
            const thinkingTime = Math.floor(Math.random() * (1500 - 600) + 600);
            await new Promise((resolve) => setTimeout(resolve, thinkingTime));
        } else {
            notValidHitId = true;
        }

        const clickedBlock = document.querySelector(`#playerBoard div[id="${hitId}"]`);

        if (playerShipsBlocks.includes(hitId) && notValidHitId === false) {
            setCurrentSuccessAttack((prevSuccessAttack) => [...prevSuccessAttack, hitId]);
            if (firstSuccessAttack.length === 0) {
                setFirstSuccessAttack([hitId]);
            }
            if (nextSuccessAttack === null) {
                setNextSuccessAttack(true);
            }
            clickedBlock.classList.add("success-att");
            setPlayerAttackedBlocks((prevPlayerAttackedBlocks) => [...prevPlayerAttackedBlocks, hitId]);
        } else {
            if (nextSuccessAttack === true && currentSuccessAttack.length >= 1) {
                setNextSuccessAttack(false);
            } else if (nextSuccessAttack === false) {
                let shipFound = true;

                if (currentSuccessAttack.length === 1) {
                    setTryHorizontalAttack(false);
                    setNextSuccessAttack(true);
                    shipFound = false;
                }

                if (currentSuccessAttack.length > 1 && notValidHitId === true && tryHorizontalAttack === true && hitId < 50) {
                    setTryHorizontalAttack(true);
                    setNextSuccessAttack(true);
                    shipFound = false;
                }

                if (currentSuccessAttack.length === 1 && shipFound === false && tryHorizontalAttack === false && notValidHitId === false) {
                    setCurrentSuccessAttack([]);
                    setFirstSuccessAttack([]);
                    setDecrement(1);
                    setNextSuccessAttack(null);
                    setTryHorizontalAttack(true);
                    shipFound = false;
                }

                if (currentSuccessAttack.length > 1 && shipFound === true && tryHorizontalAttack === false) {
                    setCurrentSuccessAttack([]);
                    setFirstSuccessAttack([]);
                    setDecrement(1);
                    setNextSuccessAttack(null);
                    setTryHorizontalAttack(true);
                    shipFound = false;
                }

                if (currentSuccessAttack.length > 1 && shipFound === true && tryHorizontalAttack === true) {
                    setCurrentSuccessAttack([]);
                    setFirstSuccessAttack([]);
                    setDecrement(1);
                    setNextSuccessAttack(null);
                    setTryHorizontalAttack(true);
                }
            }

            if (notValidHitId === true) {
                setPcTryAgain((prevValue) => prevValue + 1);
                return;
            }

            clickedBlock.classList.add("missed-att");
        }
        setHittedBlocks((prevHittedBlocks) => [...prevHittedBlocks, hitId]);
        setPcTurn(false);
    }

    function gameRestart() {
        setGameStarted(false);
        const updatedShips = ships.map((ship) => ({
            ...ship,
            isVisible: true,
        }));
        setShips(updatedShips);
        setPcShipsBlocks([]);
        setPlayerShipsBlocks([]);
        setPcAttackedBlocks(0);
        setPlayerAttackedBlocks([]);
        setHorizontal(true);
        setPcTurn(false);
        setPcTryAgain(0);
        setCurrentSuccessAttack([]);
        setFirstSuccessAttack([]);
        setHittedBlocks([]);
        setNextSuccessAttack(null);
        setTryHorizontalAttack(true);
        setDecrement(1);
        setGameEnd(false);
        createBoards();
        setPcShips();
        setOpenModal(false);
    }

    function renderBubbleSpeech() {
        return bubbleSpeech ? <span className="speech-bubble show">{bubbleSpeech}</span> : null;
    }

    function renderShipSize(ship) {
        const handleSpanHover = (e) => {
            shipSizeRef.current = parseInt(e.target.id);
        };

        const shipSizes = [];
        for (let i = 0; i < ship.shipSize; i++) {
            shipSizes.push(
                <span
                    key={ship.name + i}
                    id={i}
                    style={{
                        display: "inline-block",
                        width: "3.5vw",
                        height: "3.5vw",
                        maxWidth: "38px",
                        maxHeight: "38px",
                    }}
                    onMouseEnter={handleSpanHover}
                ></span>
            );
        }
        return shipSizes;
    }

    return (
        <div>
            <div className="container-xxl">
                <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex flex-column">
                        <h5 className="mb-2">Your Score: {yourScore}</h5>
                        <i
                            className="fas fa-user-secret mb-1 text-center"
                            style={{
                                fontSize: 60,
                                color: "#FEB4BE",
                            }}
                        ></i>
                        <div className="text-center" style={{ height: 24 }}>
                            {!pcTurn && gameStarted && !gameEnd && <span>Your turn!</span>}
                        </div>
                    </div>
                    <div className="d-flex flex-column">
                        <h5 className="mb-2">Pc Score: {pcScore}</h5>

                        <i
                            className="fas fa-robot text-center"
                            style={{
                                fontSize: 60,
                                color: "aqua",
                            }}
                        ></i>
                        <div className="position-relative">
                            {pcTurn && !gameEnd && (
                                <div className="position-relative">
                                    <i className="gear"></i>
                                    <i className="gear"></i>
                                </div>
                            )}
                            <div className="d-flex justify-content-center">{renderBubbleSpeech()}</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="d-flex justify-content-around">
                        {/* Player's Board */}
                        <div className="d-flex flex-column">
                            <div className="d-flex justify-content-center mb-4 fw-bold">{playerAttackedBlocks.length} / 18 hits left to loose!</div>
                            <div className="d-flex">
                                <div className="board-numbers">
                                    <div></div>
                                    <div>1</div>
                                    <div>2</div>
                                    <div>3</div>
                                    <div>4</div>
                                    <div>5</div>
                                    <div>6</div>
                                    <div>7</div>
                                    <div>8</div>
                                    <div>9</div>
                                    <div>10</div>
                                </div>
                                <div className="main-border d-flex flex-wrap">
                                    <div className="board-letters">
                                        <div>A</div>
                                        <div>B</div>
                                        <div>C</div>
                                        <div>D</div>
                                        <div>E</div>
                                        <div>F</div>
                                        <div>G</div>
                                        <div>H</div>
                                        <div>I</div>
                                        <div>J</div>
                                    </div>
                                    <div id="playerBoard" className="d-flex flex-wrap"></div>
                                </div>
                            </div>
                        </div>
                        {/* Place Your Ships */}
                        <div className="d-flex flex-column">
                            <div className={gameStarted ? "d-none" : ""}>
                                <div className="d-flex flex-column justify-content-center">
                                    <div className="mb-4 text-center fw-bold">Place your ships</div>
                                    <div id="shipBoard" className={["ship-board", "mb-1", "d-flex", horizontal ? "flex-column" : ""].join(" ")}>
                                        {ships.map((ship, index) => {
                                            if (ship.isVisible) {
                                                return (
                                                    <div
                                                        key={index}
                                                        id={index}
                                                        className={["elevation-effect", ship.name].join(" ")}
                                                        style={{
                                                            width: horizontal ? `${ship.shipSize * 3.5}vw` : "3.5vw",
                                                            height: horizontal ? "3.5vw" : `${ship.shipSize * 3.5}vw`,
                                                            maxWidth: horizontal ? `${ship.shipSize * 40 - 2}px` : "38px",
                                                            maxHeight: horizontal ? "38px" : `${ship.shipSize * 40 - 2}px`,
                                                        }}
                                                        draggable={ship.isVisible}
                                                        onTouchStart={touchStart}
                                                        onTouchMove={touchMove}
                                                        onTouchEnd={touchEnd}
                                                        onDragStart={touchStart}
                                                    >
                                                        {renderShipSize(ship)}
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })}
                                    </div>
                                    <Button variant="contained" onClick={() => setHorizontal((prev) => !prev)}>
                                        Flip the ships
                                    </Button>
                                </div>
                            </div>
                            {/* PC Board */}
                            <div className={gameStarted ? "" : "d-none"}>
                                <div className="d-flex justify-content-center mb-4 fw-bold">{pcAttackedBlocks} / 18 hits left to win!</div>
                                <div className="d-flex">
                                    <div className="board-numbers">
                                        <div></div>
                                        <div>1</div>
                                        <div>2</div>
                                        <div>3</div>
                                        <div>4</div>
                                        <div>5</div>
                                        <div>6</div>
                                        <div>7</div>
                                        <div>8</div>
                                        <div>9</div>
                                        <div>10</div>
                                    </div>
                                    <div className="main-border d-flex flex-wrap">
                                        <div className="board-letters">
                                            <div>A</div>
                                            <div>B</div>
                                            <div>C</div>
                                            <div>D</div>
                                            <div>E</div>
                                            <div>F</div>
                                            <div>G</div>
                                            <div>H</div>
                                            <div>I</div>
                                            <div>J</div>
                                        </div>
                                        <div
                                            id="pcBoard"
                                            className={`${pcTurn ? "disabledBoard" : ""} ${isMobile() ? "pcBoard-default-style" : "pcBoard"} d-flex flex-wrap`}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {gameStarted ? (
                        <div className="d-flex justify-content-center mt-5">
                            <Button variant="contained" onClick={() => setOpenModal(true)}>
                                Restart the game
                            </Button>
                            <Modal
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                                aria-labelledby="parent-modal-title"
                                aria-describedby="parent-modal-description"
                            >
                                <Box className="modal-container">
                                    <h5 id="parent-modal-title">Are you sure that you want to restart the game?</h5>
                                    <p id="parent-modal-description">All the game progress will be lost!</p>
                                    <div className="d-flex justify-content-between">
                                        <Button variant="contained" onClick={() => gameRestart()}>
                                            Yes, restart the game!
                                        </Button>
                                        <Button variant="contained" onClick={() => setOpenModal(false)}>
                                            No!
                                        </Button>
                                    </div>
                                </Box>
                            </Modal>
                        </div>
                    ) : (
                        <></>
                    )}
                    {/* Win Modal */}
                    <Modal
                        open={gameEnd}
                        onClose={() => setOpenModal(false)}
                        disableBackdropClick={true}
                        disableEscapeKeyDown={true}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                    >
                        <Box className="modal-container text-center">
                            <h5 id="parent-modal-title">{pcAttackedBlocks === 18 ? "YOU WIN!" : playerAttackedBlocks.length === 18 ? "YOU LOSE!" : ""}</h5>
                            <p id="parent-modal-description">
                                {pcAttackedBlocks === 18
                                    ? "It seems you were lucky! Play again?"
                                    : playerAttackedBlocks.length === 18
                                    ? "Better luck next time! Play again?"
                                    : ""}
                            </p>
                            <div className="d-flex justify-content-center mt-3">
                                <Button variant="contained" onClick={() => gameRestart()}>
                                    Play Again!
                                </Button>
                            </div>
                        </Box>
                    </Modal>
                </div>
            </div>
        </div>
    );
}

export default BattleShips;

if (document.getElementById("BattleShips")) {
    ReactDOM.render(<BattleShips />, document.getElementById("BattleShips"));
}
